import { Card, Col, Container, Row } from "react-bootstrap";
import { DashboardMetric } from "..";
import { useDonorQuery } from "../../../queries";
import { useNavigate } from "react-router-dom";
import { StatusCount } from "../../../models";

export function MedicalChartDashboard() {
    const navigate = useNavigate();
    const {
        mcrDashboardQuery: { data, isFetching },
    } = useDonorQuery({ queryType: "mcr-dashboard" });

    const handleMetricClick = (metric: StatusCount) => {
        if (metric.listSlug) {
            navigate(`/lists/${metric.listSlug}/cases`);
        }
    };

    if (isFetching || !data) return null;

    return (
        <Container>
            <h1 className="me-2">Medical Chart Review Dashboard</h1>

            <Row className="gx-3">
                <Col className="mb-3">
                    <Card>
                        <Card.Body className="bg-canvas">
                            <Row lg={4} md={3} sm={1} className="d-flex justify-content-center">
                                {data.metrics.map((metric) => (
                                    <Col key={metric.status}>
                                        <DashboardMetric
                                            title={metric.status}
                                            value={metric.count}
                                            onClick={() => handleMetricClick(metric)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
